import React from 'react';
import Input from '../../../../../../components/Input/Input';
import Button from '../../../../../../components/Button/Button';
import './DetailsGroup.css';
import { useLocation, useNavigate } from 'react-router-dom';

const DetailsGroup = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const group = state?.group || {};
  const action = state?.action || 'view';

  const handleEdit = () => {
    navigate(-1);
  };

  return (
    <div className="detail-group-page">
      <div className="detail-group-container">
        <div className="title-container">
          <h1 className="page-title">
            Consult <span className="highlight">Groups</span>
          </h1>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Group name</label>
            <Input
              type="text"
              value={group?.name || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Services offered</label>
            <Input
              type="text"
              value={group?.services || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Role</label>
            <Input
              type="text"
              value={group?.role || ''}
              disabled={true}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Date added</label>
            <Input
              type="text"
              value={group?.dateAdded || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Date of group registration</label>
            <Input
              type="text"
              value={group?.dateOfGroupRegister || ''}
              disabled={true}
            />
          </div>
        </div>

        {action === 'edit' && (
          <div className="button-container">
            <Button
              children="Cancel"
              onClick={handleEdit}
              className="edit-button"
              fullWidth
              variant="warning"
            />
            <Button
              children="Save"
              onClick={handleEdit}
              className="edit-button"
              fullWidth
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailsGroup;